export default __webpack_public_path__ + "static/media/frente.cd7577de.jpeg";